export default [
  { title: 'Transactions', routeName: 'transactions' },

  { title: 'Statistics', routeName: 'transactions-statistics' },

  { title: 'Codes', routeName: 'transactions-codes' },
];
